<template lang="pug">
v-navigation-drawer(v-model="drawer" app)
    v-list-item
        v-list-item-content
            v-list-item-title.title Power Sell
            v-list-item-subtitle Dealer Admin
    v-divider
    v-list(dense nav)
        v-list-item(v-for="item in items" :key="item.title" link @click="itemClicked(item.item)")
            v-list-item-icon
                v-icon {{ item.icon }}
            v-list-item-content
                v-list-item-title {{ item.title }}
</template>
<script>
import {menuBus} from '../main'
export default {
    data() {
        return {
            drawer: null,
            items: [
                {"icon":"mdi-domain","title":"Dealer Information", "item":0},
                 {"icon":"mdi-cogs","title":"Settings", "item":1},
                  {"icon":"mdi-car-multiple","title":"Cars", "item":2},
                   {"icon":"mdi-account-convert","title":"Referrals", "item":3},
                    {"icon":"mdi-message","title":"Updates", "item":4},
                     {"icon":"mdi-account-question-outline","title":"Enquiries", "item":5},
                        {"icon":"mdi-account-group-outline","title":"My Crew", "item":6},
                      {"icon":"mdi-code-tags","title":"Website Embed Code", "item":7},
                       {"icon":"mdi-credit-card-settings-outline","title":"Payment Details", "item":8}

            ]
        }
    },
    created() {
        menuBus.$on('togglemenu', ()=> {
            this.drawer = !this.drawer
        });
    },
    methods: {
        itemClicked: function(item) {
            menuBus.$emit('menuItem',item)
        }
    }

}
</script>